export default __webpack_public_path__ + "static/media/logo.6eeafb32.png";